var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 7.18797L6.875 8.43797L9.6875 5.62547M12.5 7.50047C12.5 10.5682 9.15377 12.7995 7.93624 13.5098C7.79787 13.5905 7.72869 13.6309 7.63105 13.6518C7.55528 13.668 7.44472 13.668 7.36895 13.6518C7.27131 13.6309 7.20213 13.5905 7.06376 13.5098C5.84623 12.7995 2.5 10.5682 2.5 7.50047V4.51147C2.5 4.01177 2.5 3.76193 2.58173 3.54716C2.65392 3.35743 2.77124 3.18814 2.92354 3.05392C3.09593 2.90199 3.32987 2.81427 3.79775 2.63881L7.14888 1.38214C7.27881 1.33341 7.34378 1.30905 7.41061 1.29939C7.4699 1.29083 7.5301 1.29083 7.58938 1.29939C7.65622 1.30905 7.72119 1.33341 7.85112 1.38214L11.2022 2.63881C11.6701 2.81427 11.9041 2.90199 12.0765 3.05392C12.2288 3.18814 12.3461 3.35743 12.4183 3.54716C12.5 3.76193 12.5 4.01177 12.5 4.51147V7.50047Z",
    stroke: "#898F9D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldTick);
export default __webpack_public_path__ + "static/media/shield-tick.efb5d9fdad18b6f2f46b9858da8cb8d0.svg";
export { ForwardRef as ReactComponent };